<script lang="ts" setup>
type Props = {
  isGiftNeed: boolean | undefined
}

defineProps<Props>()

const emit = defineEmits(['update:model-value'])

const updateValue = (value: boolean | null) => {
  emit('update:model-value', !!value)
}
</script>

<template>
  <div class="gifts-toggle">
    <div class="gifts-toggle__headline">Нужен подарок</div>

    <div class="gifts-toggle__control">
      <the-switch :model-value="isGiftNeed" @update:model-value="updateValue" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gifts-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__headline {
    font-size: 18px;
    font-weight: 800;
    color: var(--ui-text-primary);

    @include media('<tablet') {
      font-size: 14px;
    }
  }
}
</style>
